module.exports = __webpack_public_path__ + "assets/80fe119e5efa3911b9d61b265f723b3d.woff2";


//////////////////
// WEBPACK FOOTER
// ../~/@fontsource/roboto/files/roboto-latin-300-normal.woff2
// module id = 2634
// module chunks = 121